import { connect } from 'react-redux';
import { branch, compose, defaultProps, lifecycle, renderNothing, withProps } from 'recompose';
import classnames from 'classnames';
import { fetchRepeaterByKey } from '../../store/reducers/repeaters';
import { withWidgetTracking } from '../../pages/dashboard/hocs/with-widget-tracking';
import { withWidgetController } from '../../pages/dashboard/components/with-controller';
import { withGridContext } from '../../pages/dashboard/components/with-grid';
import { withSpinner } from '../../components/with-loader';
import styles from '../../styles/widgets/repeater.module.scss';
import { withWidgetLoadingHandlers } from '../../components/layout/content/with-native-loading-state';
import { SET_WIDGET_STATE_ASYNC_SUCCESS } from '../../store/reducers/application';
import { RepeaterBlock } from './index';

const mapStateToProps = (state, ownProps) => ({
  repeaterData: state.repeaters?.list[ownProps.repeaterKey] ?? {},
  loading: state.repeaters?.loading
});

const withContentRepeater = compose(
  connect(mapStateToProps, { fetchRepeaterByKey }),
  branch(({ showRepeater }) => !showRepeater, renderNothing),
  defaultProps({
    emptyStateText: 'Empty State Text',
    sliderSettings: {}
  }),
  withWidgetLoadingHandlers,
  lifecycle({
    componentDidMount() {
      const { fetchRepeaterByKey, repeaterKey, setWidgetLoadedState } = this.props;

      const getRepeaterByKey = async () => await fetchRepeaterByKey({ key: repeaterKey });
      getRepeaterByKey().then(setWidgetLoadedState(SET_WIDGET_STATE_ASYNC_SUCCESS, true));
    }
  }),
  withProps(({ repeaterData, className }) => ({
    className: classnames(styles.repeater, styles[repeaterData.styling], className)
  })),
  withWidgetController(),
  withGridContext,
  withSpinner
);

const ContentRepeater = withContentRepeater(RepeaterBlock);

const PostContentRepeater = compose(
  withProps(({ post }) => ({
    showRepeater: post?.repeater?.showRepeater,
    repeaterKey: post?.repeater?.repeaterName || post?.slug
  })),
  withContentRepeater
)(RepeaterBlock);

PostContentRepeater.displayName = 'PostContentRepeater';

const DashboardContentRepeater = compose(
  withProps(({ isWidgetHidden }) => ({
    showRepeater: !isWidgetHidden
  })),
  withContentRepeater,
  withWidgetTracking
)(RepeaterBlock);

DashboardContentRepeater.displayName = 'DashboardContentRepeater';

export { ContentRepeater, PostContentRepeater, DashboardContentRepeater };
